import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Wallet from '../../../wallet/api';
export const getSkins = createAsyncThunk('skins/pages', async ({ walletId }) => {
    try {
        return await Wallet.getSkins(walletId);
    }
    catch (err) {
        return err.response;
    }
});
export const getSkin = createAsyncThunk('jockey/id', async (asset) => {
    try {
        return await Wallet.getSkin(asset);
    }
    catch (err) {
        return err.response;
    }
});
export const initialState = {
    error: null,
    skins: null,
    skin: null,
    pending: false,
    activeSkin: ''
};
export const skins = createSlice({
    name: 'skins',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSkins.fulfilled, (state, action) => {
            state.pending = false;
            state.skins = action.payload;
        });
        builder.addCase(getSkins.rejected, (state, action) => {
            state.pending = false;
        });
        builder.addCase(getSkins.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(getSkin.fulfilled, (state, action) => {
            state.pending = false;
            state.skin = action.payload;
        });
    }
});
export default skins.reducer;
